import { render, staticRenderFns } from "./BaseToolTip.vue?vue&type=template&id=06f676d9&scoped=true&"
import script from "./BaseToolTip.vue?vue&type=script&lang=ts&"
export * from "./BaseToolTip.vue?vue&type=script&lang=ts&"
import style0 from "./BaseToolTip.vue?vue&type=style&index=0&id=06f676d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f676d9",
  null
  
)

export default component.exports